import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { useToast } from '../hooks/use-toast';
import { LocationDetails } from '../components/LocationDetails';
import { locations } from '../data/site';

export default function Contact() {
  const { toast } = useToast();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  // Existing FormSubmit integration intentionally unchanged in this design-only update.
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://formsubmit.co/performancelube915@gmail.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ...formData, _subject: 'New Contact Form Submission - Performance Lube 915', _template: 'table', _captcha: 'false' }),
      });
      if (response.ok) {
        toast({ title: 'Message Sent Successfully!', description: "Thank you for contacting us. We'll get back to you soon." });
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      toast({ title: 'Error', description: 'Failed to send message. Please try again or email us directly at performancelube915@gmail.com', variant: 'destructive' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page" data-testid="contact-page">
      <section className="page-intro"><div className="site-container"><span className="eyebrow">Performance Lube 915</span><h1 data-testid="contact-title">Contact Us</h1>
        <p>Have a question or need to schedule a service? We're here to help. Reach out to us and we'll respond as soon as possible.</p>
      </div></section>
      <section className="page-section"><div className="site-container"><div className="section-heading"><h2>Our Locations</h2></div>
        {locations.map((location) => <LocationDetails key={location.id} location={location} />)}
      </div></section>
      <section className="page-section alternate-section"><div className="site-container contact-form-layout">
        <div className="section-heading"><span className="eyebrow">Let's talk about your ride</span><h2>Send Us a Message</h2><p>Fill out the form below and our team will get back to you within 24 hours.</p></div>
        <form onSubmit={handleSubmit} className="contact-form" data-testid="contact-form">
          <div><label htmlFor="name">Full Name *</label><Input type="text" id="name" name="name" data-testid="contact-name" value={formData.name} onChange={handleChange} required placeholder="John Doe" autoComplete="name" /></div>
          <div className="form-row">
            <div><label htmlFor="email">Email Address *</label><Input type="email" id="email" name="email" data-testid="contact-email" value={formData.email} onChange={handleChange} required placeholder="john@example.com" autoComplete="email" /></div>
            <div><label htmlFor="phone">Phone Number</label><Input type="tel" id="phone" name="phone" data-testid="contact-phone" value={formData.phone} onChange={handleChange} placeholder="(915) 555-0100" autoComplete="tel" /></div>
          </div>
          <div><label htmlFor="message">Message *</label><Textarea id="message" name="message" data-testid="contact-message" value={formData.message} onChange={handleChange} required rows={6} placeholder="Tell us about your vehicle and what services you need..." /></div>
          <Button type="submit" className="brand-button" disabled={isSubmitting} data-testid="contact-submit">{isSubmitting ? 'Sending...' : 'Send Message'}</Button>
        </form>
      </div></section>
    </div>
  );
}